import type {KeyTextField} from '@prismicio/client'
import type {BlogPostDocument} from 'prismicio-types'
import type {FC} from 'react'
import {Spinner} from 'src/common/Spinner'
import {POSTS_PER_PAGE} from '../utils'
import {BlogPostCard} from './BlogPostCard'

type PostsGridProps = {
  posts: BlogPostDocument<string>[]
  loading: boolean
  currentPage: number
  pageUid: string
  buttonLabel: KeyTextField
}

export const PostsGrid: FC<PostsGridProps> = ({posts, loading, currentPage, pageUid, buttonLabel}) => {
  if (loading) {
    return <Spinner />
  }

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:max-lg:gap-x-4 lg:grid-cols-3" aria-live="polite">
      {posts.map((post, index) => (
        <BlogPostCard
          key={post.id + post.lang}
          post={post}
          index={(currentPage - 1) * POSTS_PER_PAGE + index}
          pageUid={pageUid}
          buttonLabel={buttonLabel}
        />
      ))}
    </div>
  )
}
